import Vue from 'vue'
import Router from 'vue-router'

const EvaluateList = require('@/components/evaluate/list');
const EvaluateShow = require('@/components/evaluate/show');
const EvaluateStart = require('@/components/evaluate/start');
const EvaluateReport = require('@/components/evaluate/report/show');
const EvaluateDetail = require('@/components/evaluate/detail');

const Auth = require('@/components/auth/auth');
const AuthLogin = require('@/components/auth/login');
const AuthRegister = require('@/components/auth/register');
const AuthInitialize = require('@/components/auth/initialize');
const AuthLink = require('@/components/auth/link');
const AuthResetPassword = require('@/components/auth/reset-password');

const User = require('@/components/user/user');
const Indicator = require('@/components/user/indicator');
const Evaluate = require('@/components/user/evaluate');
const Report = require('@/components/user/report');

const UserSetting = require('@/components/user/setting');
const JoinCompany = require('@/components/user/join-company');

const Tag = require('@/components/user/tag');

const Company = require('@/components/company/company');
const CompanyDashboard = require('@/components/company/dashboard');
const CompanyPostIndex = require('@/components/company/post/index');
const CompanyOrganization = require('@/components/company/organization');
const CompanyPostList = require('@/components/company/post/list');
const CompanyInvitation = require('@/components/company/invitation/list.vue');
const CompanyCompare = require('@/components/company/compare');


const CompanyPostEdit = require('@/components/company/post/edit');
const CompanyPostShow = require('@/components/company/post/show');

const CompanyHr = require('@/components/company/hr');
const CompanySetting = require('@/components/company/setting');

import store from '../store/index.js'
import * as types from '../store/mutation-types.js'
import auth from '../resource/auth'

Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/',
    redirect: '/evaluate'
  }, {
    path: '/auth/',
    name: '/auth/',
    component: Auth,
    meta: {
      anon: true
    },
    children: [{
      path: 'register',
      name: '/auth/register',
      component: AuthRegister,
      meta: {
        anon: true
      }
    }, {
      path: 'initialize/:code',
      name: '/auth/initialize',
      component: AuthInitialize,
      meta: {
        anon: true
      }
    }, {
      path: 'link',
      name: '/auth/link',
      component: AuthLink,
      meta: {
        anon: true
      }
    }, {
      path: 'login',
      name: '/auth/login',
      component: AuthLogin,
      meta: {
        anon: true
      }
    }, {
      path: 'reset_password',
      name: '/auth/reset_password',
      component: AuthResetPassword,
      meta: {
        anon: true
      }
    }]
  }, {
    path: '/user',
    // name: '/user',
    component: User,
    meta: {
      auth: true
    },
    children: [{
      path: '',
      redirect: '/user/report'
    }, {
      path: 'setting',
      name: '/user/setting',
      component: UserSetting,
      meta: {
        auth: true
      }
    }, {
      path: 'join-company',
      name: '/user/join-company',
      component: JoinCompany,
      meta: {
        auth: true
      }
    }, {
      path: 'indicators',
      name: '/user/indicators',
      component: Indicator,
      meta: {
        auth: true
      }
    }, {
      path: 'tags',
      name: '/user/tags',
      component: Tag,
      meta: {
        auth: true
      }
    }, {
      path: 'report',
      name: '/user/report',
      component: Report,
      meta: {
        auth: true
      }
    }, {
      path: 'evaluates',
      name: '/user/evaluates',
      component: Evaluate,
      meta: {
        auth: true
      }
    }]
  }, {
    path: '/company',
    component: Company,
    meta: {
      auth: true
    },
    children: [{ // 默认重定向
      path: '',
      redirect: '/company/dashboard'
    }, {
      path: 'dashboard',
      name: '/company/dashboard',
      component: CompanyDashboard,
      meta: {
        auth: true
      }
    }, {
      path: '/company/compare/:ids',
      name: 'CompanyCompare',
      component: CompanyCompare,
      meta: {
        auth: true
      }
    }, {
      path: 'hr',
      name: '/company/hr',
      component: CompanyHr,
      meta: {
        auth: true
      }
    }, {
      path: '/company/hr/:hr/dashboard',
      name: 'CompanyHRDashboard',
      component: CompanyDashboard,
      meta: {
        auth: true
      }
    }, {
      path: 'invitations',
      name: '/company/invitations',
      component: CompanyInvitation,
      meta: {
        auth: true
      }
    }, {
      path: 'organizations',
      name: '/company/organizations',
      component: CompanyOrganization,
      meta: {
        auth: true
      }
    }, {
      path: 'posts',
      component: CompanyPostIndex,
      meta: {
        auth: true
      },
      children: [{
        path: '',
        name: '/company/posts',
        component: CompanyPostList,
        meta: {
          auth: true
        }
      }, {
        path: '/company/posts/add',
        name: '/company/posts/add',
        component: CompanyPostEdit,
        meta: {
          auth: true
        }
      }, {
        path: '/company/posts/:_id/edit',
        name: '/company/posts/edit',
        component: CompanyPostEdit,
        meta: {
          auth: true
        }
      }, {
        path: '/company/posts/:_id/',
        name: '/company/posts/show',
        component: CompanyPostShow,
        meta: {
          auth: true
        }
      }]
    }, {
      path: 'setting',
      name: '/company/setting',
      component: CompanySetting,
      meta: {
        auth: true
      }
    }]
  }, {
    path: '/evaluate',
    name: 'EvaluateList',
    component: EvaluateList
  }, {
    path: '/evaluate/:code',
    name: 'EvaluateShow',
    component: EvaluateShow
  }, {
    path: '/evaluate/:code/start',
    name: 'EvaluateStart',
    component: EvaluateStart
  }, { // 测评结果
    path: '/evaluate/:code/report',
    name: 'EvaluateReport',
    component: EvaluateReport
  }, { // 测评结果
    path: '/evaluate/:code/detail',
    name: 'EvaluateDetail',
    component: EvaluateDetail
  }]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth)) {
    // 对路由进行验证
    if (store.getters.authorized) { // 已经登陆
      next()
    } else {
      auth.session({}).then(res => {
        let data = res.body
        store.commit(types.LOAD_SESSION, data.result || {}) // 重新载入数据
        if (data.code === 0 && data.result && data.result._id) {
          next()
        } else {
          next({
            path: '/auth/login',
            query: {
              refer: to.fullPath
            }
          })
        }
      }, res => {
        next({
          path: '/auth/login',
          query: {
            refer: to.fullPath
          }
        })
      })
    }
  } else if (to.matched.some(m => m.meta.anon)) {
    if (store.getters.authorized) {
      auth.session({}).then(res => {
        let data = res.body
        store.commit(types.LOAD_SESSION, data.result || {}) // 重新载入数据
        if (data.code === 0 && data.result && data.result._id) {
          next({
            path: '/'
          })
        } else {
          if (data.result && data.result.offline) {
            alert(data.result.offline.msg)
          }
          next()
        }
      }, res => {
        next()
      })
    } else {
      next()
    }
  } else {
    store.dispatch('getSession')
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js